import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initTaskObserverState: types.TaskObserverState = {
    taskObserverList: null,

    notAssignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },
}

const taskObserverReducer = produce((
    draft: types.TaskObserverState = initTaskObserverState,
    action: ActionTypes = null,
): types.TaskObserverState => {
    switch (action.type) {
        case types.TASK_OBSERVER_LIST:
            draft.taskObserverList = action.taskObserverList
            return draft

        case types.NOT_ASSIGNED_TASK_OBSERVER_IDS:
            draft.notAssignedUsers.userIds = action.userIds
            return draft

        case types.NOT_ASSIGNED_TASK_OBSERVER_SORT:
            draft.notAssignedUsers.sortColumn = action.sortColumn
            draft.notAssignedUsers.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_TASK_OBSERVER_FILTERS:
            draft.notAssignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_TASK_OBSERVER_SELECTED:
            draft.notAssignedUsers.selected = action.selected
            return draft

        default:
            return draft
    }
})
export default taskObserverReducer
